/* LWL — Kazanç çubuğu hareketleri (sepet çekmecesi + Kombin Atölyesi).
   İşaretleme sunucuda/atölyede hazır gelir ([data-lkz]); bu dosya yalnızca hareket ekler:
   ilk görünüşte soldan dolma, sepet değişince ilerleme + yeni kademe parlaması,
   görünürken 8 sn'de bir sıradaki kademeyi gösteren ipucu (görünüş başına en fazla 4).
   Dosya yüklenmese de çubuk doğru görünür. */
(function () {
	'use strict';
	if (window.__lwlKz) return;
	window.__lwlKz = true;
	var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var S = {}, EVERY = 8000, MAX = 4;
	var io = 'IntersectionObserver' in window ? new IntersectionObserver(onVis, { threshold: 0.4 }) : null;

	function tl(n) { return Math.round(n).toLocaleString('tr-TR') + ' TL'; }
	function num(el, k, d) { var v = parseFloat(el.getAttribute(k)); return isNaN(v) ? d : v; }

	function setup(el) {
		el.setAttribute('data-lkz-on', '1');
		var ctx = el.getAttribute('data-lkz') || 'x';
		var s = S[ctx] || (S[ctx] = { hints: 0, vis: false });
		var pct = num(el, 'data-pct', 0), r = num(el, 'data-reached', -1), g = num(el, 'data-gain', 0);
		var first = s.pct == null;
		var p0 = s.pct, r0 = s.reached, g0 = s.gain;
		s.el = el; s.pct = pct; s.reached = r; s.gain = g;
		if (io) io.observe(el);
		if (RM) return;
		if (first || s.needIntro) { if (io) { s.needIntro = true; preset(el); } return; }
		if (p0 !== pct || r0 !== r) { s.needIntro = false; run(el, p0, pct, r0, r, g0, g, s.vis ? 0 : 250); }
	}

	function preset(el) {
		var fill = el.querySelector('.lkz__fill'), ms = el.querySelectorAll('.lkz__m');
		if (fill) fill.style.width = '0%';
		for (var i = 0; i < ms.length; i++) ms[i].classList.remove('is-done');
		el.classList.add('is-moving');
	}

	function run(el, p0, p1, r0, r1, g0, g1, delay) {
		var fill = el.querySelector('.lkz__fill'), ms = el.querySelectorAll('.lkz__m'), gn = el.querySelector('[data-lkz-gain-num]');
		if (!fill) return;
		var n = ms.length, d = Math.min(1500, 450 + Math.abs(p1 - p0) * 18);
		el.classList.add('is-moving');
		fill.style.width = p0 + '%';
		for (var i = 0; i < n; i++) if (i > Math.min(r0, r1)) ms[i].classList.remove('is-done');
		if (gn && g0 !== g1) gn.textContent = tl(g0);
		setTimeout(function () {
			var t0 = null;
			function f(now) {
				if (t0 === null) t0 = now;
				var q = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - q, 3), p = p0 + (p1 - p0) * e;
				fill.style.width = p + '%';
				for (var i = 0; i < n; i++) {
					if (i <= r1 && !ms[i].classList.contains('is-done') && p >= (i + 1) * 100 / n - 0.5) {
						ms[i].classList.add('is-done', 'is-pop');
						(function (m) { setTimeout(function () { m.classList.remove('is-pop'); }, 520); })(ms[i]);
					}
				}
				if (gn && g0 !== g1) gn.textContent = tl(g0 + (g1 - g0) * e);
				if (q < 1) return requestAnimationFrame(f);
				fill.style.width = p1 + '%';
				for (var j = 0; j < n; j++) ms[j].classList.toggle('is-done', j <= r1);
				el.classList.remove('is-moving');
				if (g1 > g0) { el.classList.add('is-win'); setTimeout(function () { el.classList.remove('is-win'); }, 700); }
				schedule(el.getAttribute('data-lkz') || 'x', 900);
			}
			requestAnimationFrame(f);
		}, delay || 0);
	}

	/* Açılış adı: çekmecenin her açılışında bir kez, yalnız adı olan çubuklarda (çekmece/sepet). Süreyi (ms) döndürür. */
	function intro(el) {
		var t = el.querySelector('[data-lkz-title]');
		if (!t || RM) return 0;
		clearTimeout(el.__lkzT1); clearTimeout(el.__lkzT2);
		el.classList.remove('is-intro', 'is-intro-out'); void el.offsetWidth;
		if (!t.getAttribute('data-t')) t.setAttribute('data-t', t.textContent);
		var txt = t.getAttribute('data-t'), h = '';
		for (var i = 0; i < txt.length; i++) h += '<i style="--i:' + i + '">' + (txt[i] === ' ' ? ' ' : txt[i].replace(/[<>&]/g, '')) + '</i>';
		t.innerHTML = h;
		var sub = el.querySelector('[data-lkz-sub]');
		if (sub) { if (!sub.getAttribute('data-t')) sub.setAttribute('data-t', sub.textContent.trim()); var ws = sub.getAttribute('data-t').split(/\s+/), sh = ''; for (var w = 0; w < ws.length; w++) sh += '<i style="--w:' + w + '">' + ws[w].replace(/[<>&]/g, '') + '</i>'; sub.innerHTML = sh; }
		el.classList.add('is-intro');
		el.__lkzT1 = setTimeout(function () { el.classList.add('is-intro-out'); }, 2200);
		el.__lkzT2 = setTimeout(function () { el.classList.remove('is-intro', 'is-intro-out'); }, 2800);
		return 2300;
	}

	function onVis(entries) {
		entries.forEach(function (en) {
			var el = en.target, ctx = el.getAttribute('data-lkz') || 'x', s = S[ctx];
			if (!s || s.el !== el) { if (io) io.unobserve(el); return; }
			var v = en.isIntersecting;
			if (v && !s.vis) {
				s.hints = 0;
				if (!RM && (s.needIntro || ctx === 'drawer')) { s.needIntro = false; preset(el); run(el, 0, s.pct, -1, s.reached, 0, s.gain, 150 + intro(el)); }
				else schedule(ctx, 1500);
			}
			if (!v) clearTimeout(s.timer);
			s.vis = v;
		});
	}

	function schedule(ctx, ms) {
		var s = S[ctx]; if (!s || RM) return;
		clearTimeout(s.timer);
		s.timer = setTimeout(function () { hint(ctx); }, ms);
	}

	function hint(ctx) {
		var s = S[ctx], el = s && s.el;
		if (!el || !el.isConnected || !s.vis || s.hints >= MAX) return;
		if (document.hidden || el.classList.contains('is-moving')) return schedule(ctx, EVERY);
		if (!el.querySelector('.lkz__m.is-next')) return;
		s.hints++;
		el.classList.remove('is-go'); void el.offsetWidth; el.classList.add('is-go');
		setTimeout(function () { el.classList.remove('is-go'); }, 2600);
		schedule(ctx, EVERY);
	}

	function scan() {
		var els = document.querySelectorAll('[data-lkz]:not([data-lkz-on])');
		for (var i = 0; i < els.length; i++) setup(els[i]);
	}

	document.addEventListener('click', function (e) {
		var b = e.target.closest && e.target.closest('[data-lkz-how]');
		if (!b) return;
		var box = b.closest('[data-lkz]'), t = box && box.querySelector('.lkz__tbl');
		if (!t) return;
		e.preventDefault();
		t.hidden = !t.hidden;
		b.setAttribute('aria-expanded', t.hidden ? 'false' : 'true');
		b.textContent = t.hidden ? 'Nasıl çalışır?' : 'Kapat';
	});

	function start() {
		scan();
		new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
	else start();
})();
